<template>
    <div id="container" type="vpreapproval">
        <div class="page page-preapproval"  v-ga:request="{pageType:'vpreapproval', state: {}}" v-ga:page="{pageType:glb.pageType, glb: glb, state: {}}">
            <mvtHeader />

            <mvtWelcome>
                <template v-slot:img>
                    <img :src="glb.cdnUrl + 'images/desktop/preapproval/preapproval-bg.webp'" alt="Welcome Movoto Preapproved page" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <h1 class="f0 text-bold">Get Preapproved for a Mortgage Loan</h1>
                    <div class="f5">Let us help you find a local lender who can guide you through the entire preapproval process.</div>
                    <div>
                        <form v-submit="show3rdPartyForm">
                            <div class="input right input-geo large ">
                                <input ref="zipcode" type="text" name="zipcode" v-model="zipcode" v-validate="'required|zipcode'" maxlength="5"
                                    placeholder="ZIP Code" />
                                <button class="btn primary regular" type="submit">{{ cta.text }}</button>
                            </div>
                        </form>
                    </div>
                </template>
            </mvtWelcome>

            <section class="inline large">
                <div class="grid gap-3 sm-grid-cols-1 md-grid-cols-3 fixed fixed-max-sm">
                    <h2 class="wrap text-center">
                        <b class="f3 text-bold">How it Works</b>
                    </h2>
                    <div class="large inline flex vertical bg-default corner outline left">
                        <div>STEP 1</div>
                        <div><b class="f4 multipleline-2">Tell us more about yourself and your homeownership goals.</b></div>
                        <div class="body">Answer a few quick questions about yourself and the home you are looking to buy.</div>
                    </div>
                    <div class="large inline flex vertical bg-default corner outline left">
                        <div>STEP 2</div>
                        <div><b class="f4">Get matched to a lender that fits your needs.</b></div>
                        <div class="body">In seconds, we will match you to a lender that’s the best fit for your needs.</div>
                    </div>
                    <div class="large inline flex vertical bg-default corner outline left">
                        <div>STEP 3</div>
                        <div><b class="f4 multipleline-2">Receive your preapproval letter and a range for your mortgage rate.</b></div>
                        <div class="body">Provide documentation about your finances and credit history and your lender will tell you how much you’re preapproved to borrow.</div>
                    </div>
                </div>
            </section>

            <section class="inline large">
                <div class="grid gap-3 xs-grid-cols-1 fixed fixed-max-sm">
                    <h2 class="text-center">
                        <b class="f3 text-bold">Frequently Asked Questions</b>
                    </h2>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <mortgageTools :id="glb.pageType"></mortgageTools>

            <section v-if="tag" class="inline large">
                <div class="grid gap-3 xs-grid-cols-1 fixed fixed-max-sm ">
                    <div class="text-center">
                        <h2 class="f3 text-bold">Related Articles</h2>
                    </div>
                    <mvtArticle :tag="tag"/>
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-preapproval.js"></script>

